import { Component, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { NavController } from '@ionic/angular';
import { CommonService } from 'src/app/services/common.service';
import { constants } from 'src/app/utils/constants';

@Component({
  selector: 'app-tabs',
  templateUrl: 'tabs.page.html',
  styleUrls: ['tabs.page.scss'],
  standalone: false,
})
export class TabsPage implements OnInit {

  currentTabPosition: number = 0;

  constructor(
    private commonService: CommonService,
    private navController: NavController,
  ) {}

  ngOnInit(): void {
    this.commonService.getCurrentTabPosition().subscribe(tab => { this.currentTabPosition = tab });
  }

  public changeTabPosition(position: number) {
    this.currentTabPosition = position;
  }

  public async gotoChecklistAndReload() {
    this.commonService.pushCurrentTabPosition(0);
    this.commonService.clearAllLocalstorage();
    await this.navController.navigateBack(constants.PAGE.CHECKLIST, { replaceUrl: constants.TRUE });   
  }

}
